import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import format from '../../helpers/format'
import Loader from 'react-loader'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  SrOnly
} from '../'
import Styles from './RetirementPlanTable.css'

// TODO UI BASICS
// √ filter clear button
// √ table sorting
// √ filter debounce
//  + loading spinner while typing
//    for 1.5 seconds after
// √ styling
// √ mobile table

// TODO table content
// √ # of ESG options?
// √ has self-directed?
// screen results ?


@CSSModules(Styles,{allowMultiple:true})
class RetirementPlanTableThSortIcons extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    //
    return (
      <div>
        <div styleName={this.props.active && this.props.asc ? 'th-icon-active' : 'th-icon'}>
          <LinkIcon faclass='fa-caret-up' nospace/>
        </div>
        <div styleName={this.props.active && !this.props.asc ? 'th-icon-active' : 'th-icon'}>
          <LinkIcon faclass='fa-caret-down' nospace/>
        </div>
      </div>
    )
  }
}


@CSSModules(Styles,{allowMultiple:true})
export default class RetirementPlanTable extends Component {
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      sortVals: [
        // [Table label, field name, 0/1 for string/number]
        ['Plan', 'primary_plan_name'], // , 0
        ['Assets', 'plan_assets'], // , 1
        ['# of sustainable funds', 'plan_option_sri_count'], // , 1
        ['% in sustainable funds', 'percAllocSri'], // , 1
        ['Target date manager', 'default_fund_manager'], // , 0
        ['% in target date', 'percAllocDefault'], // , 1
        ['Self-directed option?', 'hasSelfDirected'] // , 1
      ],
      companies: this.resetCompanies(),
      sortVal: 0,
      sortAsc: true,
      filterVal: '',
      sortFilterTimeout: null,
      loading: false,
      debounceTime: 500
    }
  }

  calcPercAllocDefault = (company) => {
    return company.plan_assets ?
      company.allocations.default / company.plan_assets :
      -1
  }

  calcPercAllocSri = (company) => {
    return company.plan_assets ?
      company.allocations.sri / company.plan_assets :
      -1
  }

  calcHasSelfDirected = (company) => {
    return company.access_self_directed.length > 0 ? 1 : 0
  }

  resetCompanies = () => {
    const companies = Object.keys(config.plansSource).map((key, i) => {
      //
      const company = config.plansSource[key]

      // calculate values for table sort
      company.percAllocDefault = this.calcPercAllocDefault(company)
      company.percAllocSri = this.calcPercAllocSri(company)
      company.hasSelfDirected = this.calcHasSelfDirected(company)

      const companyWithPath = {
        company,
        path: key,
      }
      return companyWithPath
    })

    return companies
  }

  sortCompanies = (companies, sortVal, noFlipAsc=false) => {
    // default and secondary sort is short_name
    const defaultSortOnField = 'primary_plan_name'

    // are we clicking the column header of the existing sort?
    // if so, we want to switch ascending/descending.
    // unless we are asked not to switch it,
    // because we are being called from the filter function.
    let currAsc = this.state.sortAsc
    if (this.state.sortVal === sortVal && !noFlipAsc) {
      currAsc = !currAsc
    }

    // sort logic here
    // what are we going to use to sort?
    const currSort = this.state.sortVals[sortVal]
    const sortOnField = currSort[1]
    // const sortAsNumbers = currSort[2]

    function compareFn(_a, _b, _sortOnField) {
      if (_a.company[_sortOnField] === _b.company[_sortOnField]) return 0;
      return _a.company[_sortOnField] > _b.company[_sortOnField] ? 1 : -1;
    }

    function compareByDefaultSort(a, b) {
      return compareFn(a, b, defaultSortOnField)
    }

    function compareBySortVal(a, b) {
      return currAsc ?
        compareFn(a, b, sortOnField) :
        compareFn(b, a, sortOnField)
    }

    // first, default sort by name ascending
    companies.sort(compareByDefaultSort)
    // next, sort on requested sort
    if (currSort !== defaultSortOnField) {
      companies.sort(compareBySortVal)
    }

    return [companies, currAsc]
  }

  // core logic to filter companies
  // includes sorting logic
  filterCompanies = (filterVal) => {
    // first, we filter a fresh set of companies
    const companies = this.resetCompanies().filter((e, i) => {
      if (filterVal && filterVal.length >= 3) {
        if (
          e.company.primary_plan_name.toUpperCase().includes(filterVal.toUpperCase()) ||
          e.company.short_name.toUpperCase().includes(filterVal.toUpperCase())
        ) {
          return true
        }
      } else {
        return true
      }
      return false
    })

    // then, we sort the filtered companies
    // using the current saved Sort,
    // and not flipping the ascending.
    const sortedCompanyConfig = this.sortCompanies(companies, this.state.sortVal, true)

    return sortedCompanyConfig[0]
  }

  // these two functions are called by user interaction with table elements
  // they serve as wrappers for the logic of sorting and filtering
  sortTable = (sortVal) => {
    const sortedCompanyConfig = this.sortCompanies(this.state.companies, sortVal)
    this.setState({
      companies: sortedCompanyConfig[0],
      sortAsc: sortedCompanyConfig[1],
      sortVal
    })
  }

  // filter table has a debounce timeout
  filterTable = (filterVal) => {
    if (this.sortFilterTimeout) {
      clearTimeout(this.sortFilterTimeout)
    }

    if (filterVal && filterVal.length >= 3) {
      this.setState({
        filterVal,
        loading: true,
        sortFilterTimeout: setTimeout(
          () => {
            const filteredCompanies = this.filterCompanies(filterVal)
            this.setState({
              loading: false,
              companies: filteredCompanies,
            })
          },
          this.state.debounceTime
        )
      })
    } else {
      const filteredCompanies = this.filterCompanies(filterVal)
      this.setState({
        filterVal,
        loading: false,
        companies: filteredCompanies,
      })
    }
  }

  formatNameLink = (e) => {
    return <Link
      to={config.routes.plans + '/' + e.path}
      title={e.company.primary_plan_name}
    >
      {e.company.primary_plan_name}
    </Link>
  }

  formatPlanAssets = (e) => {
    return e.company.plan_assets ?
      format.money(e.company.plan_assets, true, 'USD', true, 1) :
      'N/A'
  }

  formatPercAllocDefault = (e) => {
    return e.company.percAllocDefault >= 0 ?
      format.perc(e.company.percAllocDefault) :
      'N/A'
  }

  formatSriCount = (e) => {
    return e.company.plan_option_sri_count > 0 ?
      e.company.plan_option_sri_count :
      <span styleName='red'>
        {e.company.plan_option_sri_count}
      </span>
  }

  formatPercAllocSri = (e) => {
    return e.company.percAllocSri >= 0 ?
      format.perc(e.company.percAllocSri) :
      'N/A'
  }

  formatHasSelfDireceted = (e) => {
    return e.company.hasSelfDirected ?
      <LinkIcon faclass='fa-check'/> :
      <span styleName='red'><LinkIcon faclass='fa-times'/></span>
  }

  render() {
    //
    return (
      <ContainerDivs>
        <div styleName='cs-out'>

          <div styleName='filter-and-table-wrap'>
            <div styleName='filter-and-table-wrap-inner'>
              <label styleName='filter-input-label' htmlFor='company-table-filter'>
                <SrOnly>Search employers by name</SrOnly>
              </label>
              <div styleName='filter-input-wrap'>

                <input
                  styleName='filter-input-input'
                  value={ this.state.filterVal }
                  onChange={ (e) => this.filterTable(e.target.value) }
                  placeholder='Search employers'
                  id='company-table-filter'
                  name='company-table-filter'
                />

                <div
                  styleName='submit'
                  className='fa fa-search'
                />

                <button
                  onClick={ (e) => this.filterTable('') }
                  styleName='filter-input-clear-btn'
                >
                  Clear
                </button>
              </div>

              { /* <p>
                {this.state.companies.length} results
              </p> */ }
              <br/>

              { /* Company picker */ }
              <table styleName='company-table'>
                <thead>
                  <tr>
                    {
                      this.state.sortVals.map((e, i) => {
                        return (
                          <th
                            onClick={ () => this.sortTable(i) }
                            key={'company-table-th-'+i}
                            styleName={'company-table-th-'+e[1]}
                          >
                            <div styleName='company-table-th-inner'>
                              {e[0]}
                              <RetirementPlanTableThSortIcons
                                active={this.state.sortVal === i}
                                asc={this.state.sortAsc}
                              />
                            </div>
                          </th>
                        )
                      })
                    }
                  </tr>
                </thead>
                {
                  this.state.loading ?
                    <tbody>
                      <tr styleName='loader-tr'>
                        <td colSpan='7' styleName='loader-td'>
                          <div styleName='loader-wrap'>
                            <Loader options={{ scale: 1, top:'50%' }} />
                          </div>
                        </td>
                      </tr>
                    </tbody> :
                    <tbody>
                      {
                        this.state.companies.map((e, i)=>{
                          return (
                            <tr key={'cmpny-' + i} >
                              <td data-label='Employer'>
                                { this.formatNameLink(e) }
                              </td>

                              <td style={{textAlign: 'right'}} data-label='Plan assets'>
                                { this.formatPlanAssets(e) }
                              </td>

                              <td style={{textAlign: 'right'}} data-label='# of sustainable funds'>
                                { this.formatSriCount(e) }
                              </td>

                              <td style={{textAlign: 'right'}} data-label='% in sustainable funds'>
                                { this.formatPercAllocSri(e) }
                              </td>

                              <td data-label='Target date manager'>
                                {e.company.default_fund_manager}
                              </td>

                              <td style={{textAlign: 'right'}} data-label='% in target date option'>
                                { this.formatPercAllocDefault(e) }
                              </td>

                              <td style={{textAlign: 'right'}} data-label='Self-directed option?'>
                                { this.formatHasSelfDireceted(e) }
                              </td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                }
              </table>

            </div>
          </div>

          <div styleName='cs-tl-sub'>
            New plans added regularly
          </div>
        </div>
      </ContainerDivs>
    )
  }
}